import {
  FULL_SCORE_AVERAGE_STARS,
  ZERO_SCORE_AVERAGE_STARS,
  STARS_DECIMALS
} from "@/utils/averageStarsThresholds";

export const LEVEL_HELP_TEXT =
  "Tu nivel sale de sumar los tres puntajes con su peso: más de 2 es A, más de 1 y hasta 2 es B, 1 o menos es C. El nivel define el precio que se te paga por plato.";

export const REFERENTIAL_SCORE_HELP_TEXT =
  "Puntaje referencial: se recalcula hoy con la fórmula vigente y puede no coincidir con la letra. La letra de esta quincena es la que se te pagó.";

export const INCIDENTS_HELP_TEXT =
  "Reclamos de tus clientes, pesados por gravedad, por cada pedido entregado. Sumas 3 puntos con 0,5 o menos por cada 100 pedidos y 0 puntos desde 1,5.";

export const DEALER_WAIT_HELP_TEXT =
  "Minutos que el repartidor espera en tu cocina después de la hora de salida de la ruta, descontando 16 minutos de margen. Se mide con lo que el repartidor marca en su app: llegada e inicio de ruta. Sumas 3 puntos con 5 minutos o menos de exceso promedio y 0 puntos desde 25. Si no hay marcas en el periodo, suma 0.";

const formatStars = (stars) => stars.toFixed(STARS_DECIMALS).replace(".", ",");

export const RATINGS_HELP_TEXT = `Promedio de estrellas que te dan tus clientes. Sumas 3 puntos con ${formatStars(
  FULL_SCORE_AVERAGE_STARS
)} o más y 0 puntos con ${formatStars(ZERO_SCORE_AVERAGE_STARS)} o menos.`;
